import moment from 'moment';
import React from 'react';
import classNames from 'classnames';

type DatePillProps = {
  date: string | Date;
  recurrence: boolean;
  completed?: boolean;
};

const DatePill: React.FC<DatePillProps> = ({ date, recurrence, completed }) => {
  if (!date) return null;

  const taskDate = moment(date);
  const referenceDate = moment();

  if (!date) {
    return null;
  }

  const className = classNames('task-date', {
    'task-date-overdue': !completed && taskDate.isBefore(referenceDate, 'day'),
    'task-date-today': !completed && taskDate.isSame(referenceDate, 'day'),
    'task-date-later': !completed && taskDate.isAfter(referenceDate, 'day'),
    'task-date-completed': completed,
    'task-recurring': recurrence,
  });

  if (taskDate.isSame(referenceDate, 'day')) {
    return <div className={className}>Today</div>;
  } else if (taskDate.isSame(referenceDate.clone().subtract(1, 'day'), 'day')) {
    return <div className={className}>Yesterday</div>;
  } else if (taskDate.isSame(referenceDate.clone().add(1, 'day'), 'day')) {
    return <div className={className}>Tomorrow</div>;
  } else {
    return (
      <div className={className}>
        <aha-date date={taskDate.toISOString()} format='medium' />
      </div>
    );
  }
};

export default DatePill;
